import { LucideProps } from 'lucide-react'

const HalfPie = (props: LucideProps) => (
  <svg
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40 0.109375C17.9086 0.109375 0 17.9935 0 40.0547C0 62.116 17.9086 80.0001 40 80.0001V0.109375Z"
      fill="#DB4245"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40 80C62.0914 80 80 62.1158 80 40.0546C80 17.9934 62.0914 0.109259 40 0.109257L40 80Z"
      fill="#F1C2C2"
    />
  </svg>
)

export default HalfPie
